var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auto-mapping-item',{attrs:{"auto-mapping-slot":_vm.autoMappingSlot,"is-mapped":false,"is-currently-mapping":_vm.isCurrentlyMapping,"disabled":_vm.disabled},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }